// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountExternalIdModel {
    static getAttributeTypeMap() {
        return AccountExternalIdModel.attributeTypeMap;
    }
}
AccountExternalIdModel.discriminator = undefined;
AccountExternalIdModel.additionalProperties = false;
AccountExternalIdModel.attributeTypeMap = [
    {
        "name": "externalIdType",
        "baseName": "externalIdType",
        "type": "AccountExternalIdType"
    },
    {
        "name": "externalId",
        "baseName": "externalId",
        "type": "string"
    },
];
//# sourceMappingURL=accountExternalIdModel.js.map